/// <amd-module name="Dashboards/WidgetContracts/Internal/WidgetCatalogProps" />
import { DashboardWidgetProps } from "./DashboardWidgetProps";

export interface WidgetCatalogProps {
    projectId: string;

    /**
     * Returns initial Widget Settings to create a widget.
     */
    onAdd: (initialWidgetSettings: DashboardWidgetProps) => void;

    /**
     * Returns initial Widget Settings to create a widget, plus dragging event from the catalog
     */
    onDrop: (initialWidgetSettings: DashboardWidgetProps, e: Event) => void;

    /**
     * Called to check that widget can be dropped from catalog - if true is returned onDrop will be called next.
     */
    isValidDropPoint: (x: number, y: number) => boolean;
}
